import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { map, Observable, startWith } from 'rxjs';
import { DemurrageService } from 'src/app/shared/service/demurrage/demurrage.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-demurrage-form',
  templateUrl: './demurrage-form.component.html',
  styleUrls: ['./demurrage-form.component.scss'],
})
export class DemurrageFormComponent {
  demurrageForm!: FormGroup;
  operationTypes = [
    { value: 'Load Port', label: 'Load Port' },
    { value: 'Discharge Port', label: 'Discharge Port' },
  ];
isLoading: boolean = false;
  despatchTermsOptions = [
    { value: 'DHD : Half Despatch', label: 'DHD : Half Despatch' },
    { value: 'FD : Free Despatch', label: 'FD : Free Despatch' },
    { value: 'DFD : Full Despatch', label: 'DFD : Full Despatch' },
    { value: 'Custom : As per CP', label: 'Custom : As per CP' },
  ];

  cargoTypes = [
    { value: 'Grains', label: 'Grains' },
    { value: 'Coal in Bulk', label: 'Coal in Bulk' },
    { value: 'Mineral Ores', label: 'Mineral Ores' },
    { value: 'Building Material', label: 'Building Material' },
    { value: 'Fertilizer', label: 'Fertilizer' },
    { value: 'Iron Ore', label: 'Iron Ore' },
    { value: 'Petcoke', label: 'Petcoke' },
    { value: 'Steel', label: 'Steel' },
    { value: 'Salt', label: 'Salt' },
    { value: 'Rice', label: 'Rice' },
    { value: 'Wheat', label: 'Wheat' },
    { value: 'Soya Beans', label: 'Soya Beans' },
    { value: 'Maize', label: 'Maize' },
    { value: 'Barley', label: 'Barley' },
    { value: 'Bagged Rice', label: 'Bagged Rice' },
  ];

  dischargeRateUnits = [
    { value: 'Per Day', label: 'Per Day' },
    { value: 'Per Hour', label: 'Per Hour' },
  ];
  dischargeTermsOptions = [
    {
      value: 'SHEX : Sun & Holidays Excl',
      label: 'SHEX : Sun & Holidays Excl',
    },
    {
      value: 'SSHEX : Sat, Sun & Holidays Excl',
      label: 'SSHEX : Sat, Sun & Holidays Excl',
    },
    {
      value: 'SHEX1 : Sat 1200 To Sun 2400 Excl',
      label: 'SHEX1 : Sat 1200 To Sun 2400 Excl',
    },
    {
      value: 'SHEX2 : Sat 1200 To Mon 0800 Excl',
      label: 'SHEX2 : Sat 1200 To Mon 0800 Excl',
    },
    {
      value: 'SHEX3 : Fri 2400 To Sun 2400 Excl',
      label: 'SHEX3 : Fri 2400 To Sun 2400 Excl',
    },
    {
      value: 'SHEX4 : Fri 1700 To Sun 2400 Excl',
      label: 'SHEX4 : Fri 1700 To Sun 2400 Excl',
    },
    {
      value: 'SHEX5 : Fri 2400 To Mon 0800 Excl',
      label: 'SHEX5 : Fri 2400 To Mon 0800 Excl',
    },
    {
      value: 'SHEX6 : Fri 1700 To Mon 0800 Excl',
      label: 'SHEX6 : Fri 1700 To Mon 0800 Excl',
    },
    {
      value: 'SHEX8 : Sat 0600 To Mon 0800 Excl',
      label: 'SHEX8 : Sat 0600 To Mon 0800 Excl',
    },
    {
      value: 'SHEX9 : Sat 1700 To Mon 0800 Excl',
      label: 'SHEX9 : Sat 1700 To Mon 0800 Excl',
    },
    { value: 'FHINC : Fri Holidays Incl', label: 'FHINC : Fri Holidays Incl' },
    {
      value: 'FHEX : Fri Holidays Excepted',
      label: 'FHEX : Fri Holidays Excepted',
    },
    {
      value: 'FHEX1 : Fri & Holidays Excl',
      label: 'FHEX1 : Fri & Holidays Excl',
    },
    {
      value: 'FHEX2 : Wed 1700 To Sat 0800 Excl',
      label: 'FHEX2 : Wed 1700 To Sat 0800 Excl',
    },
    {
      value: 'FHEX3 : Thu 1700 To Sun 0800 Excl',
      label: 'FHEX3 : Thu 1700 To Sun 0800 Excl',
    },
    {
      value: 'EGYPT : Thu 1400 To Sun 0800 Excl',
      label: 'EGYPT : Thu 1400 To Sun 0800 Excl',
    },
    {
      value: 'FHEX4 : Fri 1200 To Sun 0800 Excl',
      label: 'FHEX4 : Fri 1200 To Sun 0800 Excl',
    },
    {
      value: 'CQD : Customary Quick Despatch',
      label: 'CQD : Customary Quick Despatch',
    },
    {
      value: 'CQD1 : Customary Quick Despatch SHINC',
      label: 'CQD1 : Customary Quick Despatch SHINC',
    },
    {
      value: 'FHEX6 : Thu 1700 To Sat 0800 Excl',
      label: 'FHEX6 : Thu 1700 To Sat 0800 Excl',
    },
    {
      value: 'FHEX6 - THU 1700 TO SAT 0800',
      label: 'FHEX6 - THU 1700 TO SAT 0800',
    },
    {
      value: 'SHEX UU : Sun & Holidays UU Excl',
      label: 'SHEX UU : Sun & Holidays UU Excl',
    },
    {
      value: 'SSHEX UU : Sat, Sun & Holidays UU Excl',
      label: 'SSHEX UU : Sat, Sun & Holidays UU Excl',
    },
    {
      value: 'SHEX10 : SUN 0600 To Mon 0800 Excl',
      label: 'SHEX10 : SUN 0600 To Mon 0800 Excl',
    },
    {
      value: 'SHINC : Sun & Holidays Incl',
      label: 'SHINC : Sun & Holidays Incl',
    },
    {
      value: 'SSHINC : Sat, Sun & Holidays Incl',
      label: 'SSHINC : Sat, Sun & Holidays Incl',
    },
  ];

  eventOptions = [
    'NORT Invalid',
    'Inward Passage',
    'Immigration/Port Authority',
    'Tide',
    'Pumping Delays',
    'First Day Window',
    'Document Allowance',
    'Weather',
    'Others',
  ];
  clientOptions: any[] = [];
  charterpartyOptions: string[] = [
    'ASBATANKVOY',
    'EXXONMOBIL VOY 2005',
    'BPVOY4',
  ];

  filteredCharterpartyOptions!: Observable<string[]>;
  vesselList: any;
  constructor(
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private demurrageService: DemurrageService,
    private overlayService: OverlapService,
    private route: ActivatedRoute,
    private portRequestFormService: PortRequestFormServiceService,
  ) {
    this.demurrageForm = this.fb.group({
      voyage: this.fb.group({
        vessel: ['', Validators.required],
        vessel_imo: [''],
        voyage_no: [''],
        charterparty_terms: [''],
        allowed_laytime_hours: [0],
        demurrage_rate_usd_per_day: [0],
        address_commission_percent: [0],
        undisputed_demurrage_paid: [0],
        freight: [''],
        bl_dated: [''],
        cp_dated: [''],
        laycan: [''],
        // laycan_narrowed: [''],
        laycan_narrowed_date: [''],
        laycan_narrowed_start_time: [''],
        laycan_narrowed_end_time: [''],
        actual_rotation: [''],
        cp_speed: [''],
        timebar_clause: [''],
        additional_laytime: [''],
        client_name: [''],
        charteres_name: [''],
      }),

      load_ports: this.fb.array([]),

      discharge_ports: this.fb.array([]),
      final_pdf: [false],
      report_scope: ['BOTH']
    });
    this.addLoadPort();
    this.addDischargePort();
    this.filteredCharterpartyOptions = this.voyageForm
      .get('charterparty_terms')!
      .valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value || '')),
      );
    this.filteredVessels = this.voyageForm.get('vessel')!.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterVessels(value || '')),
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.charterpartyOptions.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }
  isEditMode = false;
  currentDemurrageId: number | null = null;
  ngOnInit(): void {
    this.loadClientOptions();
    this.loadVessels();
    this.route.queryParams.subscribe((params) => {
      this.isEditMode = params['mode'] === 'edit';

      if (this.isEditMode && params['id']) {
        this.currentDemurrageId = +params['id'];
        this.loadDemurrage(this.currentDemurrageId);
      } else {
        this.currentDemurrageId = null;
      }
    });
  }
  loadDemurrage(id: number) {
    this.isLoading = true;
    this.demurrageService.getDemurrageById(id).subscribe({
      next: (res: any) => {
        console.log(res);

        this.demurrageForm.patchValue({
          voyage: {
            ...res.voyage,
            bl_dated: this.formatDateForInput(res.voyage?.bl_dated),
            cp_dated: this.formatDateForInput(res.voyage?.cp_dated),
          },
        });

        const loadPorts: any[] = [];
        const dischargePorts: any[] = [];

        Object.keys(res).forEach((key) => {
          if (key.startsWith('Load Port')) {
            loadPorts.push(res[key]);
          } else if (key.startsWith('Discharge Port')) {
            dischargePorts.push(res[key]);
          }
        });

        this.setLoadPorts(res.load_ports || loadPorts);
        this.setDischargePorts(res.discharge_ports || dischargePorts);
        this.isLoading = false;
      },
    });
  }
  formatDateForInput(date: string | null): string {
    return date ? date.split('T')[0] : '';
  }
  setLoadPorts(data: any[]) {
    this.loadPorts.clear();
    data.forEach((port) => {
      const deductionsArray = this.fb.array(
        (port.deductions || []).map((item: any) =>
          this.fb.group({
            event_name: [item.event_name],
            start_time: [item.start_time],
            end_time: [item.end_time],
            to_count: [item.to_count],
            comments_clause: [item.comments_clause],
          })
        )
      );

      this.loadPorts.push(
        this.fb.group({
          port: [port.port],
          terminal: [port.terminal],
          start_time: [port.start_time],
          start_event: [port.start_event],
          end_time: [port.end_time],
          end_event: [port.end_event],
          comments_clause: [port.comments_clause],
          deductions: deductionsArray,
        })
      );
    });
    if (this.loadPorts.length === 0) {
      this.addLoadPort();
    }
  }

  setDischargePorts(data: any[]) {
    this.dischargePorts.clear();
    data.forEach((port) => {
      const deductionsArray = this.fb.array(
        (port.deductions || []).map((item: any) =>
          this.fb.group({
            event_name: [item.event_name],
            start_time: [item.start_time],
            end_time: [item.end_time],
            to_count: [item.to_count],
            comments_clause: [item.comments_clause],
          })
        )
      );

      this.dischargePorts.push(
        this.fb.group({
          port: [port.port],
          terminal: [port.terminal],
          start_time: [port.start_time],
          start_event: [port.start_event],
          end_time: [port.end_time],
          end_event: [port.end_event],
          comments_clause: [port.comments_clause],
          deductions: deductionsArray,
        })
      );
    });
    if (this.dischargePorts.length === 0) {
      this.addDischargePort();
    }
  }
  loadClientOptions() {
    this.requestFormService.getClientList().subscribe({
      next: (res: any[]) => {
        this.clientOptions = res.map((client) => ({
          ...client,
          client_name:
            client.client_name === 'EMZ OIL' ? 'EMZOIL' : client.client_name,
        }));
      },
      error: (err) => console.error('Client API error', err),
    });
  }
  get voyageForm(): FormGroup {
    return this.demurrageForm.get('voyage') as FormGroup;
  }

  get loadPorts(): FormArray {
    return this.demurrageForm.get('load_ports') as FormArray;
  }

  get dischargePorts(): FormArray {
    return this.demurrageForm.get('discharge_ports') as FormArray;
  }

  createPortGroup(): FormGroup {
    return this.fb.group({
      port: [''],
      terminal: [''],
      start_time: [''],
      start_event: [''],
      end_time: [''],
      end_event: [''],
      comments_clause: [''],
      deductions: this.fb.array([]),
    });
  }

  createDeductionGroup(): FormGroup {
    return this.fb.group({
      event_name: [''],
      start_time: [''],
      end_time: [''],
      to_count: [''],
      comments_clause: [''],
    });
  }

  addLoadPort() {
    this.loadPorts.push(this.createPortGroup());
  }

  removeLoadPort(index: number) {
    this.loadPorts.removeAt(index);
  }

  addDischargePort() {
    this.dischargePorts.push(this.createPortGroup());
  }

  removeDischargePort(index: number) {
    this.dischargePorts.removeAt(index);
  }

  getLoadDeductions(portIndex: number): FormArray {
    return this.loadPorts.at(portIndex).get('deductions') as FormArray;
  }

  addLoadDeduction(portIndex: number) {
    const deductions = this.getLoadDeductions(portIndex);
    const newGroup = this.createDeductionGroup();
    deductions.push(newGroup);
  }

  removeLoadDeduction(portIndex: number, index: number) {
    this.getLoadDeductions(portIndex).removeAt(index);
  }

  getDischargeDeductions(portIndex: number): FormArray {
    return this.dischargePorts.at(portIndex).get('deductions') as FormArray;
  }

  addDischargeDeduction(portIndex: number) {
    const deductions = this.getDischargeDeductions(portIndex);
    const newGroup = this.createDeductionGroup();
    deductions.push(newGroup);
  }

  removeDischargeDeduction(portIndex: number, index: number) {
    this.getDischargeDeductions(portIndex).removeAt(index);
  }

  onEventNameChange(event: Event, type: 'load' | 'discharge', pIndex: number, dIndex: number) {
    const value = (event.target as HTMLSelectElement).value;
    if (value === 'First Day Window') {
      const portArray = type === 'load' ? this.loadPorts : this.dischargePorts;
      const portStartTime = portArray.at(pIndex).get('start_time')?.value;
      const deductions = type === 'load' ? this.getLoadDeductions(pIndex) : this.getDischargeDeductions(pIndex);
      
      const currentStartTime = deductions.at(dIndex).get('start_time')?.value;
      if (portStartTime && !currentStartTime) {
        deductions.at(dIndex).patchValue({ start_time: portStartTime });
      }
    }
  }

  submit() {
    const finalPdf = this.demurrageForm.value.final_pdf || false;
    const reportScope = this.demurrageForm.value.report_scope || 'BOTH';
    const payload = {
      id: this.currentDemurrageId,
      voyage: {
        ...this.demurrageForm.value.voyage,
        final_pdf: this.demurrageForm.value.final_pdf || false,
        final_pdf_date: finalPdf ? new Date().toISOString() : null,
      },
      report_scope: reportScope,
      load_ports: this.demurrageForm.value.load_ports,
      discharge_ports: this.demurrageForm.value.discharge_ports,
    };

    console.log(payload);

    this.demurrageService
      .generateDemurragePdf(payload)
      .subscribe((response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        this.overlayService.showPdf(blob);
      });
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  filteredVessels!: Observable<any[]>;
  loadVessels(): void {
    this.isLoading = true;
    this.portRequestFormService.getVessels().subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.vesselList = (res.vessels || []).map((v: any) => ({
            ...v,
            vesselName: this.toTitleCase(v.vesselName),
          }));

          this.filteredVessels = this.voyageForm
            .get('vessel')!
            .valueChanges.pipe(
              startWith(''),
              map((value) => this.filterVessels(value || '')),
            );
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Vessel Load Error:', err);
        this.isLoading = false;
      },
    });
  }
  filterVessels(value: any): any[] {
    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : value?.vesselName?.toLowerCase() || '';

    return this.vesselList.filter((v: any) =>
      v.vesselName.toLowerCase().includes(filterValue),
    );
  }
  displayVessel(vessel: any): string {
    return vessel ? vessel.vesselName : '';
  }
onVesselSelected(event: any): void {
  const vessel = event.option.value;
const normalize = (name: string) =>
  (name || '')
    .replace(/FZCO/gi, '')
    .replace(/EMZ OIL/gi, 'EMZOIL')
    .trim()
    .toLowerCase();

const matchedClient = this.clientOptions.find(
  (client: any) =>
    normalize(client.client_name) === normalize(vessel.client_name)
);

  this.voyageForm.patchValue({
    vessel: vessel.vesselName,
    vessel_imo: vessel.vesselIMO,
    client_name: matchedClient ? matchedClient.client_name : ''
  });
}
  toTitleCase(value: string): string {
    return value
      ? value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : '';
  }

  calculateHours(startTime: string | null | undefined, endTime: string | null | undefined, toCount: number | string | null | undefined = null): string {
    if (!startTime || !endTime) return '';
    const start = new Date(startTime);
    const end = new Date(endTime);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return '';
    
    const diffMs = end.getTime() - start.getTime();
    if (diffMs < 0) return '0.00';
    
    let diffHrs = diffMs / (1000 * 60 * 60);
    
    if (toCount !== null && toCount !== undefined && toCount.toString() !== '') {
      diffHrs = diffHrs * (Number(toCount) / 100);
    }
    
    return diffHrs.toFixed(2);
  }

  getGrossLaytimeUsed(type: 'load' | 'discharge', portIndex: number): string {
    const formArray = type === 'load' ? this.loadPorts : this.dischargePorts;
    const portGroup = formArray.at(portIndex) as FormGroup;
    if (!portGroup) return '0.00';
    return this.calculateHours(portGroup.get('start_time')?.value, portGroup.get('end_time')?.value) || '0.00';
  }

  getTotalDeductions(type: 'load' | 'discharge', portIndex: number): string {
    const deductions = type === 'load' ? this.getLoadDeductions(portIndex) : this.getDischargeDeductions(portIndex);
    if (!deductions) return '0.00';
    let total = 0;
    for (let i = 0; i < deductions.length; i++) {
      const item = deductions.at(i);
      const hoursStr = this.calculateHours(item.get('start_time')?.value, item.get('end_time')?.value, item.get('to_count')?.value);
      if (hoursStr) {
        total += parseFloat(hoursStr);
      }
    }
    return total.toFixed(2);
  }

  getNetLaytimeUsed(type: 'load' | 'discharge', portIndex: number): string {
    const gross = parseFloat(this.getGrossLaytimeUsed(type, portIndex)) || 0;
    const deductions = parseFloat(this.getTotalDeductions(type, portIndex)) || 0;
    return (gross - deductions).toFixed(2);
  }

  getOverallGrossLaytimeUsed(type: 'load' | 'discharge'): string {
    const formArray = type === 'load' ? this.loadPorts : this.dischargePorts;
    let total = 0;
    for (let i = 0; i < formArray.length; i++) {
      total += parseFloat(this.getGrossLaytimeUsed(type, i)) || 0;
    }
    return total.toFixed(2);
  }

  getOverallTotalDeductions(type: 'load' | 'discharge'): string {
    const formArray = type === 'load' ? this.loadPorts : this.dischargePorts;
    let total = 0;
    for (let i = 0; i < formArray.length; i++) {
      total += parseFloat(this.getTotalDeductions(type, i)) || 0;
    }
    return total.toFixed(2);
  }

  getOverallNetLaytimeUsed(type: 'load' | 'discharge'): string {
    const gross = parseFloat(this.getOverallGrossLaytimeUsed(type)) || 0;
    const deductions = parseFloat(this.getOverallTotalDeductions(type)) || 0;
    return (gross - deductions).toFixed(2);
  }
}
